var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1416e015e2142cab158e800d37947aaed31676c3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webflow-js@sharesy"]={id:"1416e015e2142cab158e800d37947aaed31676c3"};
      